/*
Respirator Parts
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Respirator Parts'
const id = 'x221OQB1HGaRId879JwT'

export default {
  name,
  id,
  filters,
  headers,
  form
}
